import React from "react";
import store from "store";
import $ from "jquery";
import Page from "../Page";
import { trans } from "../Lang";
import { QueryParam, API_GUIDE, BASE_URL } from "../Util";
import { Row, Col, Collapsible, CollapsibleItem } from "react-materialize";
import Sticky from "react-sticky-el";

class Guide extends Page {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      content: "",
    };
  }

  componentDidMount() {
    this.handleLoadData();
  }

  handleLoadData() {
    $.getJSON(API_GUIDE).then((data) => {
      const { title, content } = data.payload;
      this.setState({ title, content });
    });
  }

  render() {
    let { title, content } = this.state;

    return (
      <div className="pb-m border-bottom">
        <div className="ptb-l text-center" style={{ background: "#D8EDF8" }}>
          <h5 className="font-heavy catalog-title" style={{ fontSize: "36px" }}>
            {title}
          </h5>
        </div>
        <div className="mt-m container narrow">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    );
  }
}

export default Guide;



// WEBPACK FOOTER //
// ./src/components/Public/Guide.js